// Section + game catalog. Mode builders live in quizgen.js.
import { IMG, ANIMALS } from "./data";
import * as Q from "./quizgen";
export { IMG };

const m = (id, title, emoji, desc, kind, build) => ({ id, title, emoji, desc, kind, build });

export const SECTIONS = [
  { id: "abc", title: "ABC Adventure", short: "ABC", emoji: "🔤", desc: "A–Z letters & sounds", color: "yellow", image: IMG.abc, path: "/learn/abc", modes: [
    m("recognition", "Letter Recognition", "👀", "Hear it, find it", "quiz", Q.abcModes.recognition),
    m("sounds", "Letter Sounds", "🔊", "A to Z, in order", "quiz", Q.abcModes.sounds),
    m("match", "Letter to Picture", "🖼️", "A is for Apple", "quiz", Q.abcModes.match),
    m("case", "Big & Small Letters", "Aa", "Uppercase → lowercase", "quiz", Q.abcModes.case),
  ] },
  { id: "numbers", title: "Numbers", short: "Numbers", emoji: "🔢", desc: "Count 1–20", color: "blue", image: IMG.numbers, path: "/learn/numbers", modes: [
    m("recognition", "Number Recognition", "👀", "1 to 20, in order", "quiz", Q.numberModes.recognition),
    m("count", "Count Objects", "🍎", "How many?", "quiz", Q.numberModes.count),
    m("order", "Number Ordering", "📶", "Smallest to biggest", "order", Q.numberOrderRounds),
    m("moreless", "More vs. Less", "⚖️", "Which has more?", "quiz", Q.numberModes.moreless),
  ] },
  { id: "colors", title: "Colors", short: "Colors", emoji: "🎨", desc: "15 rainbow colors", color: "pink", image: IMG.rainbow, path: "/learn/colors", modes: [
    m("identify", "Identify the Color", "🎨", "Name that color", "quiz", Q.colorModes.identify),
    m("objects", "Match Objects to Colors", "🍎", "What's red?", "quiz", Q.colorModes.objects),
    m("find", "Find the Color", "🔎", "Spot the color", "quiz", Q.colorModes.find),
    m("sort", "Color Sorting", "🪣", "Sort into buckets", "sort", Q.colorSortRounds),
  ] },
  { id: "shapes", title: "Shapes", short: "Shapes", emoji: "🔷", desc: "15 friendly shapes", color: "purple", image: IMG.shapes, path: "/learn/shapes", modes: [
    m("recognition", "Shape Recognition", "👀", "Name that shape", "quiz", Q.shapeModes.recognition),
    m("match", "Match Shapes", "🧩", "Find the twin", "quiz", Q.shapeModes.match),
    m("find", "Find the Shape", "🔎", "Spot the shape", "quiz", Q.shapeModes.find),
    m("sort", "Shape Sorting", "🪣", "Sort into buckets", "sort", Q.shapeSortRounds),
    m("objects", "Shapes Around Us", "🍕", "Shape-to-object", "quiz", Q.shapeModes.objects),
  ] },
  { id: "animals", title: "Animals", short: "Animals", emoji: "🐶", desc: "20 animal friends", color: "green", image: IMG.animals, path: "/learn/animals", modes: [
    m("recognition", "Animal Recognition", "👀", "Who is that?", "quiz", Q.animalModes.recognition),
    m("sounds", "Animal Sounds", "🔊", "Who says Moo?", "quiz", Q.animalModes.sounds),
    m("soundmatch", "Match Animal to Sound", "🐮", "What does it say?", "quiz", Q.animalModes.soundmatch),
    m("habitat", "Where Do They Live?", "🏡", "Animal habitats", "quiz", Q.animalModes.habitat),
    m("find", "Find the Animal", "🔎", "Spot the animal", "quiz", Q.animalModes.find),
  ] },
  { id: "fruits", title: "Fruits", short: "Fruits", emoji: "🍎", desc: "Yummy & healthy", color: "orange", image: IMG.fruits, path: "/learn/fruits", modes: [
    m("recognition", "Fruit Recognition", "👀", "Find the fruit", "quiz", Q.fruitModes.recognition),
    m("name", "Fruit Names", "🏷️", "What's it called?", "quiz", Q.fruitModes.name),
    m("colors", "Fruit Colors", "🎨", "What color is it?", "quiz", Q.fruitModes.colors),
    m("healthy", "Healthy Choices", "💪", "Healthy vs. treats", "quiz", Q.fruitModes.healthy),
    m("count", "Fruit Counting", "🔢", "Count the fruit", "quiz", Q.fruitModes.count),
  ] },
  { id: "everyday", title: "Everyday Things", short: "Everyday", emoji: "🎒", desc: "Toys, clothes & more", color: "sky", image: IMG.everyday, path: "/learn/everyday", modes: [
    m("toys", "Toys", "🧸", "Find the toy", "quiz", Q.everydayModes.toys),
    m("clothes", "Clothes", "👕", "What do we wear?", "quiz", Q.everydayModes.clothes),
    m("food", "Food", "🍞", "Yummy things", "quiz", Q.everydayModes.food),
    m("household", "Household", "🛋️", "Things at home", "quiz", Q.everydayModes.household),
    m("school", "School", "✏️", "Things for school", "quiz", Q.everydayModes.school),
    m("identify", "What Kind of Thing?", "🧠", "Identify & match", "quiz", Q.everydayModes.identify),
  ] },
  { id: "matching", title: "Matching", short: "Matching", emoji: "🧩", desc: "Pair them up", color: "purple", image: IMG.matching, path: "/learn/matching", modes: [
    m("picture", "Picture → Picture", "🖼️", "Find the twins", "match", Q.matchingModes.picture),
    m("name", "Object → Name", "🏷️", "Match the word", "match", Q.matchingModes.name),
    m("letter", "Letter → Picture", "🔤", "A is for...", "match", Q.matchingModes.letter),
    m("quantity", "Number → Quantity", "🔢", "3 means ⭐⭐⭐", "match", Q.matchingModes.quantity),
    m("color", "Color → Object", "🎨", "Red like an apple", "match", Q.matchingModes.color),
    m("shape", "Shape → Object", "🔷", "Round like a ball", "match", Q.matchingModes.shape),
  ] },
  { id: "counting", title: "Counting", short: "Counting", emoji: "🧮", desc: "Count 1–20 & add", color: "blue", image: IMG.counting, path: "/learn/counting", modes: [
    m("objects", "Count Objects 1–20", "⭐", "Count them all", "quiz", Q.countingModes.objects),
    m("select", "Select the Number", "👆", "Count & tap", "quiz", Q.countingModes.select),
    m("animals", "Count Animals", "🐶", "How many puppies?", "quiz", Q.countingModes.animals),
    m("fruits", "Count Fruits", "🍓", "How many berries?", "quiz", Q.countingModes.fruits),
    m("toys", "Count Toys", "🧸", "How many teddies?", "quiz", Q.countingModes.toys),
    m("addition", "Adding Together", "➕", "2 + 3 = ?", "quiz", Q.countingModes.addition),
  ] },
  { id: "tracing", title: "Tracing", short: "Tracing", emoji: "✏️", desc: "Trace letters & shapes", color: "yellow", image: IMG.tracing, path: "/learn/tracing", modes: [
    m("letters", "Letters A–Z", "🔤", "Trace the alphabet", "trace", null),
    m("numbers", "Numbers 1–20", "🔢", "Trace the numbers", "trace", null),
    m("shapes", "Shapes", "🔷", "Trace basic shapes", "trace", null),
  ] },
];

export const CATEGORIES = SECTIONS.map(s => ({ ...s, total: s.modes.length }));
export const getSection = (id) => SECTIONS.find(s => s.id === id);

export const GAMES = [
  { id: "memory", title: "Memory Game", desc: "Flip & match cards", emoji: "🧠", color: "purple", path: "/play/memory", image: IMG.memory },
  { id: "catch-stars", title: "Catch the Stars", desc: "Tap the falling stars", emoji: "⭐", color: "yellow", path: "/play/catch-stars", image: IMG.catch_stars },
  { id: "find-object", title: "Find the Object", desc: "Spot it in the scene", emoji: "🔎", color: "sky", path: "/play/find-object", image: IMG.find_object },
  { id: "sort-match", title: "Sort & Match", desc: "Put things in buckets", emoji: "🎯", color: "green", path: "/play/sort-match", image: IMG.sort_match },
  { id: "pattern", title: "Pattern Play", desc: "What comes next?", emoji: "🧩", color: "purple", path: "/play/pattern" },
  { id: "copycat", title: "Copycat", desc: "Watch, then repeat", emoji: "🧠", color: "pink", path: "/play/copycat" },
  { id: "shadow", title: "Shadow Match", desc: "Match the shadow", emoji: "🌚", color: "blue", path: "/play/shadow" },
  { id: "different", title: "Which is Different?", desc: "Spot the odd one", emoji: "✨", color: "orange", path: "/play/different" },
];

// Legacy shape kept for the Animal Sounds mini game.
export const ANIMAL_LESSONS = ANIMALS.slice(0, 8).map(a => ({
  ask: `Which animal says "${a.sound}"?`, correct: a.key,
  options: Q.shuffle([a, ...ANIMALS.filter(x => x.key !== a.key).slice(0, 3)]).map(x => ({ key: x.key, label: x.label, img: x.img, emoji: x.emoji })),
}));
